import React from 'react';
import { FloatingActionButtonsBody } from './FloatingActionButtonsBody.js';
import { useUserSetting } from '@soulhx/client-store';

export const FloatingActionButtons = () => {
  const { settingValue: showActionBtns } = useUserSetting<boolean>('generalShowActionBtns');

  if (!showActionBtns) return null;
  return <FloatingActionButtonsBody />;
};

export default FloatingActionButtons;
